const STEPS = [
  {
    step: '1',
    icon: 'ri-search-line',
    title: '找到店家',
    description: '輸入店家名稱與地區，從公開 Google Places 資料中找出正確的商家。',
  },
  {
    step: '2',
    icon: 'ri-group-line',
    title: '比較附近同業',
    description: '以相同主要類別與鄰近範圍，取得附近同業的評分與評論數中位數。',
  },
  {
    step: '3',
    icon: 'ri-bar-chart-box-line',
    title: '產出健康度與優先順序',
    description: '依 11 項指標計算 0–100 健康度，並排出最該優先改善的方向。',
  },
];

export default function StepsSection() {
  return (
    <section className="w-full border-y border-background-300 bg-background-100">
      <div className="ds-container py-14 md:py-20">
        <div className="max-w-2xl">
          <h2>三個步驟，完成商家快篩</h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600 md:text-lg">
            全程使用公開資料，不需登入 Google，也不用連結 Google Business Profile。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {STEPS.map((item) => (
            <div key={item.step} className="rounded-2xl border border-background-300 bg-background-50 p-6 shadow-card">
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-700">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <span className="text-sm font-semibold uppercase tracking-wider text-foreground-400">
                  Step {item.step}
                </span>
              </div>
              <h3 className="mt-5 text-lg text-foreground-950 md:text-xl">{item.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-foreground-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}